import React from 'react';
import './CommonLoader.css';

/**
 * CommonLoader — shared loading spinner used across Payroll modules.
 * @param {string} message - Text displayed next to the spinner (default: "Loading…")
 */
export default function CommonLoader({ message = 'Loading…' }) {
    return (
        <div className="cl-wrapper">
            <div className="cl-spinner" />
            {message}
        </div>
    );
}
